import {makeGetNeighborhoodsDentalGuide} from 'main/factories/usecases';
import {UseDistrictsGuideQueryParams} from '../../queries/useDistrictsGuideQuery/types';

export async function getDistrictsGuide(params: UseDistrictsGuideQueryParams) {
	const response = await makeGetNeighborhoodsDentalGuide().get(params);
	if (!response.bairros || response.bairros.length === 0) {
		return [];
	}
	return response.bairros.filter(district => district?.nmBairro);
}
